(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[312],{

/***/ 11430:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/dynamic-template-page",
      function () {
        return __webpack_require__(33325);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LG": function() { return /* binding */ LG; },
/* harmony export */   "MD": function() { return /* binding */ MD; },
/* harmony export */   "l": function() { return /* binding */ buttonThemes; }
/* harmony export */ });
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);

var buttonThemes = {
    iris: {
        color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].iris */ .Z.iris,
        background: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white
    },
    black: {
        color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud,
        background: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white
    },
    white: {
        color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white,
        background: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud
    }
};
// PLAY BUTTON SIZES
var MD = "md";
var LG = "lg";


/***/ }),

/***/ 33325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DynamicTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60460);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var components_templates_dynamic_template_dynamic_template__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9329);
/* harmony import */ var utils_dynamicPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34949);
/* harmony import */ var components_templates_generator_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86922);
/* harmony import */ var _base_template_page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49019);





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}






var getDynamicData = function() {
    var _ref = _async_to_generator(function(param) {
        var superInitialProps, req, res, pageConfig, data, segmentsDynamicsFetchMapper, dynamicData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    superInitialProps = param.superInitialProps, req = param.req, res = param.res;
                    pageConfig = superInitialProps.pageConfig;
                    data = {};
                    if (!(pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.template)) return [
                        3,
                        2
                    ];
                    segmentsDynamicsFetchMapper = (0,components_templates_generator_config__WEBPACK_IMPORTED_MODULE_4__/* .getSegmentsDynamicsFetchMapper */ .Zi)(pageConfig.template);
                    return [
                        4,
                        (0,utils_dynamicPage__WEBPACK_IMPORTED_MODULE_3__/* .fetchDynamicSegmentsRequestFromServer */ .bc)({
                            pageConfig: pageConfig,
                            segmentsDynamicsFetchMapper: segmentsDynamicsFetchMapper,
                            req: req,
                            res: res
                        })
                    ];
                case 1:
                    dynamicData = _state.sent().dynamicData;
                    data = dynamicData;
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getDynamicData(_) {
        return _ref.apply(this, arguments);
    };
}();
var setFaqSeoData = function(param) {
    var superInitialProps = param.superInitialProps, req = param.req, res = param.res;
    var pageConfig = superInitialProps.pageConfig;
    if (pageConfig) {
        var seoFAQ = (0,utils_dynamicPage__WEBPACK_IMPORTED_MODULE_3__/* .getFaqData */ .RE)({
            pageConfig: pageConfig,
            res: res,
            req: req
        });
        if ((seoFAQ === null || seoFAQ === void 0 ? void 0 : seoFAQ.length) > 0) {
            pageConfig.seoFAQ = seoFAQ;
        }
    }
};
var DynamicTemplatePage = /*#__PURE__*/ function(BaseTemplatePage1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(DynamicTemplatePage, BaseTemplatePage1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(DynamicTemplatePage);
    function DynamicTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, DynamicTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(DynamicTemplatePage, [
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    statusCode: errorCode
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_templates_dynamic_template_dynamic_template__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var req = param.req, res = param.res, asPath = param.asPath;
                return _async_to_generator(function() {
                    var superInitialProps, dynamicData;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _base_template_page__WEBPACK_IMPORTED_MODULE_5__["default"].getInitialProps({
                                        req: req,
                                        res: res,
                                        asPath: asPath
                                    })
                                ];
                            case 1:
                                superInitialProps = _state.sent();
                                setFaqSeoData({
                                    req: req,
                                    res: res,
                                    superInitialProps: superInitialProps
                                });
                                return [
                                    4,
                                    getDynamicData({
                                        req: req,
                                        res: res,
                                        superInitialProps: superInitialProps
                                    })
                                ];
                            case 2:
                                dynamicData = _state.sent();
                                superInitialProps.dynamicData = dynamicData;
                                return [
                                    2,
                                    superInitialProps
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return DynamicTemplatePage;
}(_base_template_page__WEBPACK_IMPORTED_MODULE_5__["default"]);



/***/ }),

/***/ 32777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75650);
/* harmony import */ var _constants_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27639);


/* harmony default export */ __webpack_exports__["Z"] = ({
    showMenu: true,
    hideLogin: false,
    showButton: true,
    hideLanguagePicker: false,
    logoHref: _constants_links__WEBPACK_IMPORTED_MODULE_1__/* .ROOT_LINK */ .yjY,
    logoSrc: _constants_links__WEBPACK_IMPORTED_MODULE_1__/* .MONDAY_LOGO_SRC */ .Onk,
    buttonConfig: {
        buttonType: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_0__/* .SIGNUP_BUTTON_TYPE */ .ge
    }
});


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5961,4102,2448,7883,8835,7905,7053,4800,627,6720,7445,8124,9019,3971,349,3548,918,6922,9774,2888,179], function() { return __webpack_exec__(11430); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);